<template>
  <div class="mb-4 team-asset-upload d-flex flex-column justify-content-center">
    <div
      v-if="isUploading"
      class="progress"
    >
      <div
        class="progress-bar"
        role="progressbar"
        :style="{width: `${progress}%`}"
        :aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {{ progress }}%
      </div>
    </div>

    <upload-dropzone
      v-else
      class="w-100"
      upload-icon="cloud-upload"
      :accept="accept"
      :upload-text="uploadText"
      :upload-helper-text="uploadHelperText"
      @change-file="onChangeFile"
    />
  </div>
</template>

<script>
import maps from '@/generated/maps.js'

import { computed } from 'vue'

import UploadDropzone from '../upload-dropzone.vue'
import { useTeamAssets } from './use-team-assets'
import { useUploadTeamAsset } from './use-upload-team-asset'

export default {
  name: 'TeamAssetUpload',
  components: { UploadDropzone },
  props: {
    overrideAllowExtensionList: {
      type: Array,
      required: false,
      default: () => null
    }
  },
  emits: ['uploaded'],
  setup (props, { emit }) {
    const { category, prependTeamAsset } = useTeamAssets()
    const { progress, isUploading, uploadTeamAsset, allowExtensionList, accept } = useUploadTeamAsset(category, props.overrideAllowExtensionList)

    const uploadText = computed(() => {
      return `Click or Drag File to Upload ${maps.App_Models_TeamAsset.categoriesMap[category.value]}`
    })

    const uploadHelperText = computed(() => {
      const files = allowExtensionList.value.map(file => file.toUpperCase()).join(', ')
      return `${files} (max 5MB)`
    })

    const onChangeFile = async (file) => {
      const teamAsset = await uploadTeamAsset(file)

      if (teamAsset) {
        prependTeamAsset(teamAsset)

        emit('uploaded', teamAsset)
      }
    }

    return {
      progress,
      accept,
      uploadText,
      uploadHelperText,
      isUploading,
      onChangeFile
    }
  }
}
</script>

<style scoped>
.team-asset-upload {
  min-height: 10rem;
}
</style>
